import { MobXProviderContext } from "mobx-react"
import React from "react"

import RootStore from "./RootStore"

// NOTE: RootStoreのinitializeDataメソッドを除外し、Storeだけが残るようにしている
type Stores = {
  [RootStoreParameter in Exclude<keyof RootStore, "initializeData">]: RootStore[RootStoreParameter]
}

export function useStores(): Stores {
  return React.useContext(MobXProviderContext) as Stores
}
